// REFSIX-745: how a match's event minutes are displayed. Recorded minutes are
// always elapsed time; a stopping clock deducts prior stoppages when shown.
export enum EventTimekeeping {
    runningClock = "runningClock", // default: elapsed time, stoppages included
    stoppingClock = "stoppingClock", // College / High-school / Futsal: prior stoppages in the period deducted
}
